import styled, {css, SimpleInterpolation} from 'styled-components';
import Media from '../../../assets/styles/media';

export const PageCtn = styled.div`
  display: flex;
  width: 90%;
  padding: 4vw 0 100px 6vw;

  ${Media.Below.desktop`
    flex-direction: column;
  `}
`;

export const InfoBoxCtn = styled.div`
  display: flex;
  width: 50%;

  ${Media.Below.desktop`
    width: 100%;
    margin-bottom: 30px
  `}
`;

export const InfoBoxContent = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 475px;
`;

export const ParagraphSection = styled.p`
  display: flex;
  > p {
    font-size: 18px;
  }

  > div {
    min-width: 25px;
    margin-right: 20px;
  }
`;

export const PageHeaderText = styled.span`
  font-size: 40px;
  font-weight: bold;

  ${Media.Below.tablet`
    font-size: 15px;
  `}

  ${Media.Below.mobileLarge`
    font-size: 15px;
  `}
`;

export const AccessMessage = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  
  > svg {
    width: 40px;
    height: 40px;
    stroke: red;
  }
`;

export const ResponseTable = styled.table`
  margin-bottom: 20px;
`;

export const TableHead = styled.th`
  background-color: #0082bd;
  color: white;
`;

export const TableRow = styled.tr`
`;

interface TableCellProps {
  criticalCode: boolean;
}

export const TableCell = styled.td<TableCellProps>`
  text-align: center;
  background-color: #fff;
  
  ${(props): SimpleInterpolation => !props.criticalCode && css`
    background-color: #d3e7f0;
  `}
  
`;